import { configureStore } from '@reduxjs/toolkit'
import { applyMiddleware,Middleware, Store } from 'redux';
import { persistCombineReducers, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import reducers from '../reducers';
import slices from '../slices';
import rootSaga from '../sagas';

import { StoreState } from '../types';

import middleware, { sagaMiddleware } from './middleware';

const rootReducer = persistCombineReducers<StoreState>(
  {
    key: 'root',
    stateReconciler: autoMergeLevel2,
    storage,
    whitelist: [],
    timeout: 0,
  },
  {...reducers, ...slices}
);

const store: Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: any) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(middleware)
});

sagaMiddleware.run(rootSaga);

/* istanbul ignore next */
export const configStore = (initialState: any = {}, additionalMiddleware: Middleware[] = []) => {
  return {
    persistor: persistStore(store),
    store,
  }
};

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

